import { render, staticRenderFns } from "./update-img-button.vue?vue&type=template&id=5f0a34ce&"
import script from "./update-img-button.vue?vue&type=script&lang=js&"
export * from "./update-img-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports